/**
 * This module has the hook, declaration types and tests for the cartAddProduct mutation
 * {@label CART_ADD_PRODUCT}
 */
import useCartAddProduct from './hook'

export * as mutation from './mutation'
export * as types from './types'
export default useCartAddProduct
